/**
 * Created by Administrador on 24/11/2016.
 */
(function(){
    'use strict';

    angular
        .module('completeAir')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider', 'CONFIG'];

    function stateConfig($stateProvider, CONFIG) {
        $stateProvider
            .state('penalties', {
                parent: 'app',
                url: '/penalties',
                data: {
                    authorities: CONFIG.AUTHORITIES_ALL
                },
                views:{
                    'main@':{
                        templateUrl: 'app/admin/configGeneral/rates/penalty/penalties.html',
                        controller: 'penaltiesCtrl',
                        controllerAs: 'vm',
                        resolve: {
                            translatePartialLoader: ['translationHandler', function (translationHandler) {
                                return translationHandler.translateRefresh(['penalty','operation']);
                            }],
                            penalties: ['operationService',function(operationService){
                                return operationService.getOperations(true);
                            }]
                        }
                    }
                }
            })
            .state('penaltyEdit', {
                parent: 'app',
                url: '/penalty/:id/edit',
                data: {
                    authorities: CONFIG.AUTHORITIES_ALL
                },
                views:{
                    'main@':{
                        templateUrl: 'app/admin/configGeneral/rates/penalty/editPenalty.html',
                        controller: 'editPenaltyCtrl',
                        controllerAs: 'vm',
                        resolve: {
                            translatePartialLoader: ['translationHandler', function (translationHandler) {
                                return translationHandler.translateRefresh(['penalty','operation']);
                            }],
                            penalty: ['operationService','$stateParams',function(operationService,$stateParams){
                                return operationService.getOperation($stateParams.id);
                            }]
                        }
                    }
                }
            })
    }
})();
